<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Pagos del Evento</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="refrescarPagos">
          <v-icon left>refresh</v-icon>
          Actualizar
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <PagosFiltros 
          :estados="estadosPago"
          @filtrosChanged="aplicarFiltros"
        />

        <PagosTabla
          ref="pagosTabla"
          :evento-id="eventoId"
          :filtros="filtros"
          @verPago="abrirVerPago"
          @editarPago="abrirEditarPago"
        />
      </v-card-text>
    </v-card>

    <PagoDialog
      ref="pagoDialog"
      @actualizar="refrescarPagos"
    />
  </div>
</template>

<script>
import PagosFiltros from './components/PagosFiltros.vue';
import PagosTabla from './components/PagosTabla.vue';
import PagoDialog from './components/PagoDialog.vue';

export default {
  name: 'PagosEvento',
  components: {
    PagosFiltros,
    PagosTabla,
    PagoDialog
  },
  data() {
    return {
      filtros: {
        estado: '',
        fechaDesde: null,
        fechaHasta: null,
        busqueda: ''
      },
      estadosPago: [
        { text: 'Todos', value: '' },
        { text: 'Aprobado', value: 'pago_realizado' },
        { text: 'En Revisión', value: 'pago_en_revision' },
        { text: 'Rechazado', value: 'pago_rechazado' },
        { text: 'Pendiente', value: 'pago_pendiente' }
      ]
    };
  },
  computed: {
    eventoId() {
      return this.$route.params.id;
    }
  },
  methods: {
    aplicarFiltros(nuevosFiltros) {
      this.filtros = { ...this.filtros, ...nuevosFiltros };
    },
    
    refrescarPagos() {
      this.$refs.pagosTabla.cargarDatos();
    },
    
    abrirVerPago(pago) {
      this.$refs.pagoDialog.abrirDialog(pago, 'ver');
    },
    
    abrirEditarPago(pago) {
      this.$refs.pagoDialog.abrirDialog(pago, 'editar');
    }
  }
};
</script>